import { render, staticRenderFns } from "./list-shop-item.vue?vue&type=template&id=e5626f0c"
import script from "./list-shop-item.vue?vue&type=script&lang=js"
export * from "./list-shop-item.vue?vue&type=script&lang=js"
import style0 from "./list-shop-item.vue?vue&type=style&index=0&id=e5626f0c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports